import ScannerSettings from "@/components/attendance/ScannerSettings";
import AuditLog from "@/components/attendance/AuditLog";
import CentersAdmin from "@/components/attendance/CentersAdmin";
import { useAtt } from "./AttendanceLayout";
import { PageTitle } from "./AttDashboard";

export function AttSoftware() {
  const { isAdmin } = useAtt();
  return <div><PageTitle title="Software" crumb="Software › Scanner Configuration" /><ScannerSettings isAdmin={isAdmin} /></div>;
}

export function AttError() {
  const { centers } = useAtt();
  return <div><PageTitle title="Error / Audit Log" crumb="Error" /><p className="text-sm text-slate-500 -mt-4 mb-4">Every capture, re-capture, verify, delete, template access and device test — with device and result. Failures are shown in the Result column.</p><AuditLog centers={centers} /></div>;
}

export function AttCenters() {
  const { centers, batches, reload } = useAtt();
  return <div><PageTitle title="Centers & Logins" /><CentersAdmin centers={centers} batches={batches} reload={reload} /></div>;
}
